import axios from "axios";
import {
  Encrypt,
  decode,
  packCipherText,
  DecryptByVersion,
  API_CRYPTO_V2,
  API_CRYPTO_HEADER,
} from "@/utils/AES";
let AES_Urls = ["/user/login"];

// ===== 导入混淆后的请求头配置（保护敏感算法） =====
import { getSecureHeaders } from '@peter/frontend-utils';
import CryptoJS from 'crypto-js';
import { deviceInfo } from "@/utils/deviceInfo";

let RSA_publicKey = "";
let lastUpdateTimeOfToken = 0;
let fromToken = "";
let hasShownGatewayDialog = false;

function showGatewayErrorAndGoHome() {
  if (hasShownGatewayDialog) return;
  hasShownGatewayDialog = true;

  const overlay = document.createElement("div");
  overlay.id = "gateway-error-dialog";
  overlay.innerHTML =
    '<div class="gateway-error-dialog__mask"></div>' +
    '<div class="gateway-error-dialog__box">' +
    "<p>Vui lòng nhấn xác nhận để đăng nhập lại</p>" +
    '<button type="button">Xác nhận</button>' +
    "</div>";

  const style = document.createElement("style");
  style.textContent =
    "#gateway-error-dialog{position:fixed;inset:0;z-index:9999;display:flex;align-items:center;justify-content:center;font-family:inherit;}" +
    "#gateway-error-dialog .gateway-error-dialog__mask{position:absolute;inset:0;background:rgba(0,0,0,.45);}" +
    "#gateway-error-dialog .gateway-error-dialog__box{position:relative;z-index:1;display:flex;flex-direction:column;justify-content:center;width:86%;max-width:360px;min-height:200px;padding:40px 24px 32px;background:#fff;border-radius:16px;box-shadow:0 8px 24px rgba(63,117,170,.25);text-align:center;}" +
    "#gateway-error-dialog p{margin:0 0 28px;color:#333;font-size:16px;line-height:1.5;}" +
    "#gateway-error-dialog button{width:100%;height:44px;border:0;border-radius:12px;color:#fff;font-size:16px;font-weight:500;cursor:pointer;background-image:linear-gradient(180deg,#8bbcff 0%,#5387fd 100%);box-shadow:inset 0 -1px 1px rgba(0,54,127,.58),inset 0 1px 1px rgba(255,255,255,.2);}";

  document.head.appendChild(style);
  document.body.appendChild(overlay);
  overlay.querySelector("button").addEventListener("click", function () {
    window.location.replace(window.location.origin + "/");
  });
}

const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API || "",
  timeout: 10000,
});

let encryptionFlag =
  window.location.href.indexOf("disableaes=1") > -1 ? false : true; // disableaes=1时就不加密，没有或者为0都加密

function readHeader(headers, name) {
  if (!headers) return "";
  if (typeof headers.get === "function") {
    const value = headers.get(name);
    if (value != null && value !== "") return String(value);
  }
  return headers[name] || headers[String(name).toLowerCase()] || "";
}

function applyEncryptHeaders(config, key) {
  config.headers[API_CRYPTO_HEADER] = API_CRYPTO_V2;
  config.headers["cek-k"] = key;
}

// 添加请求拦截器
service.interceptors.request.use(
  function (config) {
    //config.data = qs.stringify(config.data) // 转为formdata数据格式
    const shouldEncrypt = AES_Urls.indexOf(config.url) != -1 && encryptionFlag;
    if (config.method == "get") {
      // 请求参数加密代码  目前get请求暂时不加密
      if (shouldEncrypt) {
        config.headers["Content-Type"] = "application/text";
        let { key } = Encrypt(
          JSON.stringify(config.data),
          decode(RSA_publicKey)
        );
        applyEncryptHeaders(config, key);
        // GET 仍走明文 params，Header 带 cf-f-v + cek-k
        config.params = config.data;
      } else {
        config.params = config.data;
      }

      // 不加密
      // config.params = config.data;
    } else {
      if (shouldEncrypt) {
        config.headers["Content-Type"] = "application/text";
        console.log("decode", RSA_publicKey);
        let { cipherText, key } = Encrypt(
          JSON.stringify(config.data),
          decode(RSA_publicKey)
        );
        applyEncryptHeaders(config, key);
        config.data = packCipherText(cipherText);
      }
    }

    config.headers["x-device"] = deviceInfo.xDevice || "";
    config.headers["x-app-platform"] = deviceInfo.xAppPlatform || "";

    if (fromToken) {
      // let each request carry token
      // ['X-Token'] is a custom headers key
      // please modify it according to the actual situation
      // config.headers['x-token'] = getToken()
      config.headers["form-token"] = fromToken;
      // console.log(`${config.url}token请求为===> ${store.getters.fromToken}`);
    }

    // 获取安全签名 headers（使用 @peter/frontend-utils）
    const holeUrl = window.location.origin + process.env.VUE_APP_BASE_API + config.url;
    // const holeUrl = 'https://www-testing4-viet-dev.xosofly.com' + process.env.VUE_APP_BASE_API + config.url;

    const securityHeaders = getSecureHeaders(CryptoJS, holeUrl );
    securityHeaders.forEach(header => {
    config.headers[header.name] = header.value;
    });

    return config;
  },
  function (error) {
    return Promise.reject(error);
  }
);

// 添加响应拦截器
service.interceptors.response.use(
  function (response) {
    
    let res = response;
    if (response && response.headers['cek-s'] == 1) {
        const version =
          readHeader(response.config?.headers, API_CRYPTO_HEADER) ||
          readHeader(response.headers, API_CRYPTO_HEADER);
        res = JSON.parse(DecryptByVersion(response.data, version));
    } else {
        res = response.data;
    }

    if (response && response.headers["cek-p"]) {
      RSA_publicKey = response.headers["cek-p"];
    }

    if (response && response.headers["form-token"]) {
      const token = response.headers["form-token"];
      if (token.includes(".")) {
        const time = token.split(".")[1];
        if (time * 1 > lastUpdateTimeOfToken) {
          lastUpdateTimeOfToken = time;
          fromToken = token;
        }
      } else {
        fromToken = token;
      }
    }

    if (res.code !== 1) {
      console.log("==========> ", response.config);

      // 参数中noNotifyError为true时，不弹出错误提示
      if (
        response.config?.data?.noNotifyError ||
        response.config?.data?.indexOf("noNotifyError") >= 0
      ) {
        return res;
      }

      if (
        res.code === 1038 ||
        res.code === 1040 ||
        res.code === 20001 ||
        res.code === 10050
      ) {
        return res;
      }

      if (res.code == 10056) {
        // store.dispatch('app/getEncryptKey');
        return Promise.reject(res);
      }

      if (res && res.data && res.data.countdown) {
        return res;
      }
      if (res && res.data && res.data.is_done === 1) {
        return res;
      }

      // 根据状态码 1011 判定为要输入验证码，且验证码在data里面直接返回
      if (res.code === 1011 || res?.data?.captcha) {
        return Promise.reject(new Error(res ? JSON.stringify(res) : "Error"));
      }

      return Promise.reject(res);
    }

    return res;
  },
  function (error) {
    const status = Number(error?.response?.status);
    // 登录 302 后浏览器会自动跟跳到网关校验接口；最终 475 可在这里拦截到
    if (status === 475) {
      showGatewayErrorAndGoHome();
      return new Promise(() => {});
    }
    return Promise.reject(error);
  }
);

export default service;
